<template>
<div class="chapter">
<div class="inner_page">
<div class="reviewPage" id="rev"><h2 class="reviewPageHead"><span class="bold"><span><em class="italic"><span>Acclaim for Karen Hawkins’s bestselling<br/>
romantic novels…</span></em></span></span></h2>
<p class="reviewPageText"><span>“Luscious, romantic, witty, sexy, and emotional.”</span></p>
<p class="reviewPageSource"><span>—<em class="italic"><span>Romantic Times</span></em></span></p>
<p class="reviewPageText"><span>“Fast paced, lively, sexy and laugh-out-loud funny.”</span></p>
<p class="reviewPageSource"><span>—<em class="italic"><span>Romance and More!</span></em></span></p>
<p class="reviewPageText"><span>“Delightful…sparkling.”</span></p>
<p class="reviewPageSource"><span>—Mary Balogh</span></p></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781416538318_rev.vue?2b856c0c